<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { useWindowScroll } from '@vueuse/core';
import { UiBtn, UiIcon, UiDropdown } from '@shared/ui';
import type { UserProfileProps } from './types';
import { useUserStore } from '@/app/modules/auth/stores/UserStore';
import { useAuthStore } from '@/app/modules/auth/stores/AuthStore';
import UserAvatar from '@/app/modules/auth/widgets/UserAvatar/index.vue';

const className = 'user-profile';

withDefaults(defineProps<UserProfileProps>(), {
  label: 'Войти',
  size: 'md',
  color: 'primary',
});

const userStore = useUserStore();
const authStore = useAuthStore();

const isVisibleUserMenu = ref(false);

const openUserMenu = () => {
  isVisibleUserMenu.value = true;
};

const closeUserMenu = () => {
  isVisibleUserMenu.value = false;
};

const logoutAction = async () => {
  await authStore.setAuthLinks().then(() => {
    authStore.logout();
    navigateTo(authStore.authLinks.logout_url, { external: true });
  });
};

const { y: windowY } = useWindowScroll();
const currentIconColor = ref('white');

watch(windowY, (y) => {
  currentIconColor.value = y > 0 ? 'blue' : 'white';
});

const dropdownBtnClass = computed(() => {
  return `${className}__dropdown-btn ${currentIconColor.value === 'blue' ? '!text-gray-900' : '!text-white'}`;
});
</script>

<template>
  <div :class="className">
    <ClientOnly>
      <AuthBtn
        v-if="!userStore.currentUser"
        :label="label"
        :size="size"
        :color="color"
      />
      <template v-else>
        <UserAvatar />
        <UiBtn
          type="icon"
          icon="chevron-down"
          alt="Открыть меню пользователя"
          :class="dropdownBtnClass"
          @click="openUserMenu"
        />
        <UiDropdown
          :visible="isVisibleUserMenu"
          :offset="75"
          :class="`${className}__user-menu`"
          @close="closeUserMenu"
        >
          <template #header>
            <div class="user-menu__header">
              <UserAvatar size="xl" />
              <div class="user-menu__info">
                <p class="ui__font_bold">
                  Пользователь
                </p>
                <p class="ui__text_small ui-color__neutrals_500">
                  {{ userStore.displayName }}
                </p>
              </div>
            </div>
          </template>
          <template #default>
            <ul :class="`${className}__nav`">
              <li :class="`${className}__nav-item`">
                <button
                  :class="`${className}__btn_logout`"
                  @click="logoutAction"
                >
                  <UiIcon name="logout" />
                  Выйти
                </button>
              </li>
            </ul>
          </template>
        </UiDropdown>
      </template>
    </ClientOnly>
  </div>
</template>

<style lang="sass" src='./style.scss' />
